import { FIELD_TYPES } from "constants/template-field-type";
import ThemeConfig from "segments/core-configs/theme-config";
import ScrollableTabsConfig from "segments/desktop/core-components/scrollable-tabs/fields-config.js";

export default {
  type: FIELD_TYPES.NESTED,
  label: "Usecases Gallery",
  fields: {
    ...ThemeConfig,
    withDividerLine: {
      type: FIELD_TYPES.BOOLEAN,
      label: "With divider line"
    },
    selectedIconBackground: {
      type: FIELD_TYPES.COLOR_PICKER,
      label: "Selected icon background"
    },
    defaultSelectedTabLabel: {
      type: FIELD_TYPES.TEXT,
      label: "Default selected tab label"
    },
    usecases: ScrollableTabsConfig
  }
};
